module.exports = __webpack_public_path__ + "static/img/Pop-up.868b495d.png";